module.exports = __webpack_public_path__ + "img/pen-clip-slash.fd185ed6.svg";